import React from 'react';
import { Table, Button, Input, Select, Space, Typography, Tabs } from 'antd';
import { Search, Filter, ChevronLeft, ChevronRight } from 'lucide-react';

const { Title, Text } = Typography;
const { Option } = Select;

const SettingsImports = () => {
    const dataSource = [];

    const columns = [
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: 'State', dataIndex: 'state', key: 'state' },
        { title: 'Uploaded File', dataIndex: 'uploadedFile', key: 'uploadedFile' },
        { title: 'Error File', dataIndex: 'errorFile', key: 'errorFile' },
        { title: 'Started At', dataIndex: 'startedAt', key: 'startedAt' },
        { title: 'Completed At', dataIndex: 'completedAt', key: 'completedAt' },
        { title: 'Summary', dataIndex: 'summary', key: 'summary' },
        { title: 'Actions', key: 'actions', align: 'right' },
    ];

    const items = [
        {
            key: '1',
            label: 'Imports',
            children: (
                <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, marginTop: 16 }}>
                        <Title level={3} style={{ margin: 0, fontWeight: 600 }}>Imports</Title>
                        <Button type="primary" style={{ backgroundColor: '#2563eb', borderColor: '#2563eb', fontWeight: 500 }}>
                            Create Import
                        </Button>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                        <Space size="large">
                            <Input
                                prefix={<Search size={16} color="#94a3b8" />}
                                placeholder="Search"
                                style={{ width: 300, borderRadius: '6px' }}
                            />
                            <Text type="secondary" style={{ color: '#64748b' }}>0 Results</Text>
                        </Space>

                        <Space>
                            <Button icon={<Filter size={16} />} style={{ color: '#475569', fontWeight: 500 }}>Filter</Button>
                            <Select defaultValue="10" style={{ width: 120 }}>
                                <Option value="10">10 Per Page</Option>
                                <Option value="20">20 Per Page</Option>
                                <Option value="50">50 Per Page</Option>
                            </Select>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', borderLeft: '1px solid #e2e8f0', paddingLeft: '16px', marginLeft: '8px' }}>
                                <Text style={{ color: '#475569' }}>1 of 1</Text>
                                <Button type="text" size="small" icon={<ChevronLeft size={16} color="#64748b" />} />
                                <Button type="text" size="small" icon={<ChevronRight size={16} color="#64748b" />} />
                            </div>
                        </Space>
                    </div>

                    <Table scroll={{ x: 'max-content' }}
                        columns={columns}
                        dataSource={dataSource}
                        pagination={false}
                        bordered={true}
                        locale={{ emptyText: 'No Records Available.' }}
                        className="custom-table"
                    />
                </>
            ),
        }
    ];

    return (
        <div style={{ padding: '24px', backgroundColor: '#fff', minHeight: '100vh', borderRadius: '8px' }}>
            <Tabs defaultActiveKey="1" items={items} />
        </div>
    );
};

export default SettingsImports;
